import { render, staticRenderFns } from "./ExamsIdentifiedWarning.partial.vue?vue&type=template&id=3164ca98&scoped=true"
import script from "./ExamsIdentifiedWarning.partial.vue?vue&type=script&lang=js"
export * from "./ExamsIdentifiedWarning.partial.vue?vue&type=script&lang=js"
import style0 from "./ExamsIdentifiedWarning.partial.vue?vue&type=style&index=0&id=3164ca98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164ca98",
  null
  
)

export default component.exports